import { render, staticRenderFns } from "./MyMultiPackage.vue?vue&type=template&id=21f9d88d&scoped=true"
import script from "./MyMultiPackage.vue?vue&type=script&lang=js"
export * from "./MyMultiPackage.vue?vue&type=script&lang=js"
import style0 from "./MyMultiPackage.vue?vue&type=style&index=0&id=21f9d88d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9d88d",
  null
  
)

export default component.exports